import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAsyncData } from 'src/hooks/useAsyncData';
import { isLoading } from 'src/utils/request';
import { ApplicationState } from 'store/store';
import { BaseModal } from 'ui/BaseModal';
import { FlatAppbar } from 'ui/FlatAppbar';
import { FlatToolbar } from 'ui/FlatToolbar';
import { awardsApi } from './awardsApi';
import { ELoyaltyProvider } from './enums';
import { IAwardsResponse } from './models';
import { AwardsList } from './ui/List';

interface ViewAwardsProps {
    onClose: () => void;
    locationId?: string;
}

interface ViewAwardsDialogProps extends ViewAwardsProps {
    open: boolean;
}

const ViewAwardsDialogContent: React.FC<ViewAwardsProps> = ({ onClose, locationId }) => {
    const { t } = useTranslation();
    const { settings } = useSelector((state: ApplicationState) => state.settings);
    const [awardsResponse, setAwardsResponse] = useAsyncData<IAwardsResponse>();
    React.useEffect(() => {
        if (settings) {
            setAwardsResponse(() =>
                awardsApi.getAwards(
                    settings?.loyaltyProvider === ELoyaltyProvider.Square ||
                        settings?.loyaltyProvider === ELoyaltyProvider.Powercard,
                    locationId
                )
            );
        }
    }, [setAwardsResponse, settings, locationId]);
    return (
        <Box height="100%" width="100%" overflow="auto">
            <FlatAppbar variant="dense">
                <FlatToolbar title={t('AWARDS_TITLE')} onBack={onClose} hideUserAvatar />
            </FlatAppbar>
            <AwardsList isLoading={isLoading(awardsResponse)} awards={awardsResponse.data?.awards} />
        </Box>
    );
};

export const ViewAwardsDialog: React.FC<ViewAwardsDialogProps> = ({ open, onClose, locationId }) => (
    <BaseModal open={open} onClose={onClose} fullScreen noPadding paperSx={{ width: '100%' }}>
        <ViewAwardsDialogContent onClose={onClose} locationId={locationId} />
    </BaseModal>
);
